
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary-info/[slug]",
      function () {
        return require("private-next-pages/dispensary-info/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary-info/[slug]"])
      });
    }
  